export const DEFAULT_ETH_NODE = 'wss://mainnet.eth.aragon.network/ws'
